import { render, staticRenderFns } from "./FrequencyReport.vue?vue&type=template&id=50c08768&scoped=true"
import script from "./FrequencyReport.vue?vue&type=script&lang=js"
export * from "./FrequencyReport.vue?vue&type=script&lang=js"
import style0 from "./FrequencyReport.vue?vue&type=style&index=0&id=50c08768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c08768",
  null
  
)

export default component.exports